import { FileTextOutlined } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';
import LinkedDocument from 'components/common/LinkedDocument';
import Table from 'components/Table';
import { MobileTableType } from 'components/Table/types';
import { FORMAT_DATE_TIME_US_FOR_DISPLAY } from 'constants/days';
import deviceSizes from 'constants/deviceSizes';
import moment from 'moment';
import React, { useCallback, useMemo } from 'react';
import { IFile } from 'types/file';
import { ITransaction } from 'types/transaction';
import { formatFileSize } from 'utils';

interface IUseTransactionScannedDocsTabProps {
  transaction?: ITransaction;
}
interface IFileTableProps extends Partial<IFile> {
  key: string;
  sizeAsKb: string;
}
export const useTransactionScannedDocsTabProps = ({ transaction }: IUseTransactionScannedDocsTabProps) => {
  const filesTableColumn: ColumnsType<IFileTableProps> = useMemo(
    () => [
      {
        dataIndex: 'name',
        title: 'File',
        render: (name: string, file: Partial<IFile>) => (
          <div className='flex'>
            <div className='items-center flex mr-3'>
              <FileTextOutlined style={{ fontSize: 30 }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <LinkedDocument {...file} id={file.id || ''} size={undefined} />
            </div>
          </div>
        ),
        width: '30%',
        // sorter: (a: ITransactionListTableProps, b: ITransactionListTableProps) => a.reference.localeCompare(b.reference),
      },
      {
        dataIndex: 'createdAt',
        title: 'Uploaded Time',
        render: (createdAt: string) => <div>{moment(createdAt).format(FORMAT_DATE_TIME_US_FOR_DISPLAY)}</div>,
        // sorter: (a: ITransactionListTableProps, b: ITransactionListTableProps) => a.reference.localeCompare(b.reference),
        width: '25%',
      },
      {
        dataIndex: 'type',
        title: 'Type',
        width: '25%',
        // sorter: (a: ITransactionListTableProps, b: ITransactionListTableProps) => a.reference.localeCompare(b.reference),
      },
      {
        dataIndex: 'sizeAsKb',
        title: 'Size',
        width: '20%',
        // sorter: (a: ITransactionListTableProps, b: ITransactionListTableProps) => a.reference.localeCompare(b.reference),
      },
    ],
    [],
  );
  const appointments = transaction?.appointment || [];
  const appointmentsDataSourceArray = useMemo(
    () =>
      appointments.map(
        (appointment) =>
          appointment.scannedFiles?.map((file) => ({
            ...file,
            key: file.id || '',
            sizeAsKb: formatFileSize(file.size),
          })) || [],
      ) || [],
    [appointments],
  );
  const AppointmentWithScannedDocTable = useCallback(
    () => (
      <div>
        {appointmentsDataSourceArray.map((source, index) => {
          const appointment = appointments[index];
          return (
            <div key={appointment.id}>
              <div className='font-medium text-lg p-4'>
                Appointment {appointment.description} -{' '}
                {moment(appointment.date).format(FORMAT_DATE_TIME_US_FOR_DISPLAY)}
              </div>
              <div className='px-4 sm:px-0'>
                <Table
                  mobileDesignType={MobileTableType.RESPONSIVE_TABLE}
                  widthThreshold={deviceSizes.numbers.sm}
                  dataSource={source}
                  columns={filesTableColumn}
                  pagination={false}
                />
              </div>
            </div>
          );
        })}
      </div>
    ),
    [transaction?.appointment],
  );
  return {
    Table: AppointmentWithScannedDocTable,
  };
};
